// Sonar/client/mainLayout.js


export default {
    defaultRoute: '/entry/login',
    defaultRoutes: {
        public: '/entry/login',
        appUser: '/user/dashboard',
        appAdmin: '/admin/dashboard',
        login: '/entry/login',
        entry: '/entry',
    },
    layers: {
        base: {
            template: `<div id="root-container-wrapper" class="vh-100"><div id="dev-tools-container"></div></div>`,
            components: [
                { name: 'entry-layer', type: 'layer', layer: 'entry', container: 'root-container-wrapper' },
                { name: 'app-layer', type: 'layer', layer: 'app', container: 'root-container-wrapper' },
                { name: 'error-layer', type: 'layer', layer: 'error', container: 'root-container-wrapper' },
                { name: 'devtools', type: 'DevTools', container: 'dev-tools-container' },
                { name: 'payment-gateway', type: 'PaymentGatewayComponent', container: 'root-container-wrapper' },
            ]
        },
        entry: {
            route: '/entry',
            template: `
                <div class="ab-entry-page">
                    <div id="entry-titlebar-controls" class="electron-only-titlebar-host w-100 d-flex justify-content-end pe-2" style="position: absolute; top: 0; left: 0; height: 48px; -webkit-app-region: drag; z-index: 9999;">
                        <div id="entry-titlebar-controls-target" class="h-100" style="-webkit-app-region: no-drag;"></div>
                    </div>
                    <div class="ab-entry-branding">
                        <div id="entry-branding-logo" class="mb-4"></div>
                        <h1 class="ab-entry-headline" data-i18n="Stop Searching. Start Knowing.">Stop Searching. Start Knowing.</h1>
                        <p class="ab-entry-subline" data-i18n="Sonar provides deep insights and real-time monitoring across all your data sources. Transform raw information into actionable intelligence.">Sonar provides deep insights and real-time monitoring across all your data sources. Transform raw information into actionable intelligence.</p>
                        <ul class="ab-entry-features">
                            <li>
                                <i class="bi bi-activity"></i>
                                <div><strong data-i18n="Real-time Data Monitoring">Real-time Data Monitoring</strong><br><span data-i18n="Track key metrics and events as they happen, with instant alerts and visualizations.">Track key metrics and events as they happen, with instant alerts and visualizations.</span></div>
                            </li>
                            <li>
                                <i class="bi bi-bell-fill"></i>
                                <div><strong data-i18n="Intelligent Anomaly Detection">Intelligent Anomaly Detection</strong><br><span data-i18n="Our AI identifies unusual patterns and potential issues before they impact your operations.">Our AI identifies unusual patterns and potential issues before they impact your operations.</span></div>
                            </li>
                            <li>
                                <i class="bi bi-speedometer2"></i>
                                <div><strong data-i18n="Customizable Dashboards">Customizable Dashboards</strong><br><span data-i18n="Build personalized dashboards to visualize the data that matters most to you.">Build personalized dashboards to visualize the data that matters most to you.</span></div>
                            </li>
                        </ul>
                    </div>
                    <div class="ab-entry-card-container">
                        <div class="ab-entry-card">
                            <div id="entry-mobile-logo" class="ab-entry-mobile-logo"></div>
                            <div id="entry-component-target"></div>
                            <div class="ab-entry-card-footer">
                                <a href="/entry/login" data-i18n="Login">Login</a>
                                <span>·</span>
                                <a href="/entry/signup" data-i18n="Sign Up">Sign Up</a>
                                <span>·</span>
                                <a href="/entry/forgot-password" data-i18n="Forgot Password">Forgot Password</a>
                            </div>
                        </div>
                    </div>
                    <div class="ab-entry-terms">
                        <span>By continuing, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>.</span>
                    </div>
                </div>
            `,
            components: [
                { name: 'branding-logo', type: 'LogoComponent', container: 'entry-branding-logo', props: { desktopLogoUrl: '/public/logo.png', desktopImageHeight: '40px', logoText: 'Sonar' } },
                { name: 'mobile-logo', type: 'LogoComponent', container: 'entry-mobile-logo', props: { desktopLogoUrl: '/public/logo.png', desktopImageHeight: '40px', logoText: 'Sonar' } },
                { name: 'titlebar-controls-entry', type: 'TitleBarControls', container: 'entry-titlebar-controls-target' },
                { name: 'login-layer', type: 'layer', layer: 'login', container: 'entry-component-target', default: true },
                { name: 'signup-layer', type: 'layer', layer: 'signup', container: 'entry-component-target' },
                { name: 'forgotpassword-layer', type: 'layer', layer: 'forgotpassword', container: 'entry-component-target' }
            ]
        },

        login: { route: '/entry/login', template: `<div id="login-target"></div>`, components: [{ name: 'login-comp', type: 'Login', container: 'login-target' }] },
        signup: { route: '/entry/signup', template: `<div id="signup-target"></div>`, components: [{ name: 'signup-comp', type: 'Signup', container: 'signup-target' }] },
        forgotpassword: { route: '/entry/forgot-password', template: `<div id="forgot-target"></div>`, components: [{ name: 'forgot-comp', type: 'ForgotPassword', container: 'forgot-target' }] },

        app: {
            route: '/(user|admin)',
            template: `
                <div class="d-flex flex-column h-100">
                    <header id="main-header" class="app-header"></header>
                    <main id="main-content-area" class="d-flex flex-grow-1 overflow-hidden"></main>
                </div>
            `,
            components: [
                { name: 'shared-header-layer', type: 'layer', layer: 'shared-header', container: 'main-header' },
                { name: 'user-section-layer', type: 'layer', layer: 'user-section', container: 'main-content-area' },
                { name: 'admin-section-layer', type: 'layer', layer: 'admin-section', container: 'main-content-area' },
            ]
        },
        "shared-header": {
            template: `
                <nav class="navbar navbar-expand shadow-sm h-100" style="-webkit-app-region: drag;">
                    <div class="container-fluid">
                        <div id="logo-container" style="-webkit-app-region: no-drag;"></div>
                        <div class="ms-auto d-flex align-items-center gap-2 h-100" style="-webkit-app-region: no-drag;">
                            <div id="role-switcher-container"></div>
                            <div id="notifications-container"></div>
                            <div id="documentation-link-container"></div>
                            <div id="user-profile-menu-container"></div>
                            <div id="common-titlebar-controls" class="electron-only-titlebar-host h-100"></div>
                        </div>
                    </div>
                </nav>
            `,
            components: [
                {
                    name: 'logo', type: 'LogoComponent', container: 'logo-container',
                    props: {
                        desktopLogoUrl: '/public/logo.png',
                        mobileLogoUrl: '/public/android-chrome-192x192.png',
                        desktopImageHeight: '35px'
                    }
                },
                { name: 'role-switcher', type: 'RoleSwitcher', container: 'role-switcher-container', props: { hideFor: ['appUser'], switchableRoles: ['appUser', 'appAdmin'] } },
                { name: 'notifications', type: 'Notifications', container: 'notifications-container' },
                { name: 'documentation-link', type: 'DocumentationLink', container: 'documentation-link-container' },
                { name: 'user-menu', type: 'UserProfileMenu', container: 'user-profile-menu-container', props: { showThemeSelector: true, menuItems: [{ title: "My Profile", route: "/user/profile", icon: "bi-person-circle" }] } },
                { name: 'titlebar-controls', type: 'TitleBarControls', container: 'common-titlebar-controls' },
            ]
        },
        "user-section": {
            route: '/user',
            template: `
                <div class="d-flex flex-row h-100 w-100">
                    <aside id="user-sidebar" class="app-sidebar border-end"></aside>
                    <main id="user-content" class="flex-grow-1 overflow-auto p-1"></main>
                </div>
            `,
            components: [
                { name: 'user-menu', type: 'AppMenu', container: 'user-sidebar', props: { startingRoute: '/user/', fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'user-content-router', type: 'layer', layer: 'user-content', container: 'user-content' },
            ]
        },
        "user-content": {
            template: `<div id="user-feature-area" class="h-100"></div>`,
            components: [
                { name: 'user-dashboard-layer', type: 'layer', layer: 'user-dashboard', container: 'user-feature-area', default: true },
                { name: 'user-assistant-layer', type: 'layer', layer: 'user-assistant', container: 'user-feature-area' },
                { name: 'user-routines-layer', type: 'layer', layer: 'user-routines', container: 'user-feature-area' },
                { name: 'user-alerts-layer', type: 'layer', layer: 'user-alerts', container: 'user-feature-area' },
                { name: 'user-billing-layer', type: 'layer', layer: 'user-billing', container: 'user-feature-area' },
                { name: 'user-profile-layer', type: 'layer', layer: 'user-profile', container: 'user-feature-area' },
            ]
        },
        "user-dashboard": {
            route: '/user/dashboard',
            menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-house-door', menuOrder: 1,
            template: `<div id="user-dashboard-container" class="h-100"></div>`,
            components: [{
                name: 'user-dashboard', type: 'UserDashboard', container: 'user-dashboard-container',
                instanceId: "sonar-user-dashboard"
            }]
        },
        "user-assistant": {
            route: '/user/assistant',
            menuItem: true, menuTitle: 'AI Assistant', menuIcon: 'bi-robot', menuOrder: 5,
            template: `<div id="user-assistant-container" class="h-100"></div>`,
            components: [{ name: 'user-assistant-copilot', type: 'AdvancedAIWorkspace', container: 'user-assistant-container', props: { agentName: 'AssistantAgent', singleAgentMode: true } }]
        },
        "user-routines": {
            route: '/user/routines',
            menuItem: true, menuTitle: 'Routines', menuIcon: 'bi-arrow-repeat', menuOrder: 10,
            template: `<div id="user-routines-container" class="h-100"></div>`,
            components: [{ name: 'user-routines-crud', type: 'RoutinesCrud', container: 'user-routines-container' }]
        },
        "user-alerts": {
            route: '/user/alerts',
            menuItem: true, menuTitle: 'Alerts', menuIcon: 'bi-bell-fill', menuOrder: 20,
            template: `<div id="user-alerts-container" class="h-100"></div>`,
            components: [{ name: 'user-alerts-view', type: 'AlertsView', container: 'user-alerts-container' }]
        },
        // --- END ADDED VIEWS ---
        "user-billing": { route: '/user/billing', menuItem: true, menuTitle: 'Billing', menuIcon: 'bi-credit-card-2-front-fill', menuOrder: 30, template: `<div id="user-billing-container" class="h-100"></div>`, components: [{ name: 'user-billing-view', type: 'BillingView', container: 'user-billing-container' }] },
        "user-profile": { route: '/user/profile', hideInMenu: true, template: `<div id="user-profile-container" class="h-100"></div>`, components: [{ name: 'user-profile-view', type: 'UserProfile', container: 'user-profile-container' }] },

        "admin-section": {
            route: '/admin',
            template: `
                <div class="d-flex h-100 w-100">
                    <nav id="admin-sidebar" class="app-sidebar"></nav>
                    <div id="admin-content" class="flex-grow-1 p-1 overflow-auto"></div>
                </div>
            `,
            components: [
                { name: 'admin-menu', type: 'AppMenu', container: 'admin-sidebar', props: { startingRoute: '/admin/', fullHeight: true, collapsible: true, defaultCollapsed: true, saveState: true } },
                { name: 'admin-content-router', type: 'layer', layer: 'admin-content', container: 'admin-content' },
            ]
        },
        "admin-content": {
            template: `<div id="admin-feature-area" class="h-100"></div>`,
            components: [
                { name: 'admin-dashboard-layer', type: 'layer', layer: 'admin-dashboard', container: 'admin-feature-area', default: true },
                { name: 'admin-users-layer', type: 'layer', layer: 'admin-users', container: 'admin-feature-area' },
                { name: 'admin-user-config-layer', type: 'layer', layer: 'admin-user-config', container: 'admin-feature-area' },
            ]
        },
        "admin-dashboard": { route: '/admin/dashboard', menuItem: true, menuTitle: 'Dashboard', menuIcon: 'bi-speedometer2', menuOrder: 1, template: `<div id="admin-dashboard-container" class="h-100"></div>`, components: [{ name: 'admin-dashboard', type: 'Dashboard', container: 'admin-dashboard-container', props: { role: 'admin' } }] },
        "admin-users": { route: '/admin/users', menuItem: true, menuTitle: 'User Management', menuIcon: 'bi-people-fill', menuOrder: 10, template: `<div id="admin-users-container" class="h-100"></div>`, components: [{ name: 'admin-user-manager', type: 'UserManager', container: 'admin-users-container' }] },
        "admin-user-config": { route: '/admin/user-config', hideInMenu: true, template: `<div id="admin-user-config-container" class="h-100"></div>`, components: [{ name: 'admin-user-config-view', type: 'UserConfigurationView', container: 'admin-user-config-container' }] },
    }
};